import styled from 'styled-components'
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

export const CircularProgressContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items:center;
    width: 100%;
    height: 100%;
`

export const StyledCircularProgress = styled(CircularProgress)`

`

export const TimerSection = styled.section`
    margin-top: 4px;
    margin-left: 4px;
`


export const StyledIconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 75px;
    height: 56px;
    background: ${({color}) => color};
    color: white;
    z-index:2;
    margin-right: -14px;
    border-radius: 4px;
`

export const StyledMuiTextField = styled(TextField)`
    width: 100%;
    background: white;
`

export const FlexColumn= styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`

export const MaxHeightDiv = styled.div`
    height: 100%;
    display: flex;
    flex-wrap: nowrap !important;
` 

export const LeftContainer = styled.div`
    display: flex;
    min-width: 150px;
    overflow-y: auto;
    padding-top:10px;
    flex-wrap: nowrap;
    flex-grow: 1;
`

export const RightContainer = styled.div`
    padding-left: 15px;
    width: 550px;
    margin-bottom: 0px;
`

export const StyledMainContainer = styled.div`
    background: #f3f3f8;
    height: calc(100vh - 92px);
`

export const InnerContainer = styled.div`
    padding: 16px;
    padding-bottom:8px;
    height: 100%;
    background: rgb(243, 243, 248);
`

export const StyledDivFlex = styled.div`
    display: flex;
    gap: 22px;
`

export const StyledColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 22px;
    padding-bottom: 16px;
`

export const StyledContainer = styled.div`
    width: 100%;
`

export const StyledButtonsSection = styled.section`
    display: flex;
    height: 56px;
    align-items: center;
`

export const StyledProductsSection = styled.section`
    margin-top: 16px;
    flex-grow: 1;
    padding-right: 10px;
    margin-bottom: 20px;

    ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        border-radius: 100px;
    }

    ::-webkit-scrollbar-track {
        background: rgb(230, 230, 230);
        border-radius: 100px;
    }

    ::-webkit-scrollbar-thumb {
        background: rgb(200, 200, 200);
        border-radius: 100px;
    }
    
    ::-webkit-scrollbar-thumb:hover {
        background: rgb(175, 175, 175);
        border-radius: 100px;
    }
`

export const LastProductSection = styled.section`
`

export const StyledTitle = styled.div`
    width: auto;
    font-size: 16px;
    color: #4d4d4d;
    font-weight: 500;
    font-family: Hind Vadodara, Lucida Sans Unicode;
    margin-bottom: 5px;
    white-space: initial;
    line-height: 15px;
    max-height: 30px;
`
export const StyledSbtitle = styled.div`
    width: auto;
    font-size: 12px;
    color: #4d4d4d;
    font-weight: 300;
    font-family: Hind Vadodara, Lucida Sans Unicode;
    margin-bottom: 5px;
    white-space: initial;
    line-height: 15px;
    max-height: 30px;
    margin-left: 6px;
`

